<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('orders')"
      :columns="columns"
      :column_search="true"
      resource_url="/tailoring_outsourcing/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <order-modal ref="order_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  input_alert,
  del,
  post,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import OrderModal from "./order_modal/Index.vue";

export default {
  name: "OrdersDatatable",
  components: { GenericTable, OrderModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "create_date",
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.format_date(row.create_date) || "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          width: "20%",
          data: (row) => {
            let total_items_number = row.settings.items.length;
            let total_finished = row.tailoring_outsourcing_finished_products
              ? row.tailoring_outsourcing_finished_products.length
              : 0;
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let status = row.status_code;
            switch (row.status_code) {
              case "P":
                status = `<span class="icon has-text-info">
                          <i class="fa fa-clock-o"></i>
                        </span>
                        <span>${v.$t("pending")}</span>`;
                break;
              case "F":
                status = `<span class="icon has-text-success">
                          <i class="fa fa-check"></i>
                        </span>
                        <span>${v.$t("finished")}</span>`;
                break;
              case "R":
                status = `<span class="icon has-text-warning">
                          <i class="fa fa-scissors"></i>
                        </span>
                        <span>${v.$t("repairing")}</span>`;
                break;
            }
            return `${status} <span class="tag is-info is-light">${total_finished}/${total_items_number}</span>`;
          },
        },
        {
          title: v.$t("job"),
          searchable: false,
          width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return `${row.name || ""} | ${row.tailor || ""} | ${
            //   row.settings.delivery_date || ""
            // }`;
            return `<div class="title is-6">${row.name || ""}</div>
                    <div class="subtitle is-6 mb-0">${v.$t("tailor")} ${
              row.tailor || ""
            }</div>
                    <div class="subtitle is-6">${v.$t(
                      "expected delivery date"
                    )} ${
              v.format_date(row.settings.delivery_date) || ""
            }</div>`;
          },
        },
        {
          title: v.$t("total"),
          searchable: false,
          width: "10%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let total = row.settings.items.reduce((acc, item) => {
              return acc + Number(item.quantity) * Number(item.price);
            }, 0);
            return v.format_currency(total);
          },
        },
        {
          title: v.$t("options"),
          width: "35%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/tailoring_outsourcing", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];
            // if (row.status_code == "P")
            btns.unshift({
              args: { uuid: row.uuid },
              tooltip: v.$t("finished"),
              icon: "fa fa-flag-checkered",
              icon_class: "is-small has-text-success",
              click: (e) => {
                let uuid = e.detail.uuid;
                confirm_deletion_dialog(
                  v.$t("are you sure to mark as finished?"),
                  v,
                  () => {
                    post("/tailoring_outsourcing/delivered", { uuid: uuid })
                      .then(() => {
                        v.refresh();
                      })
                      .catch((error) => {
                        error_message(error);
                      });
                  }
                );
              },
            });

            // if (row.status_code == "R")
            btns.unshift({
              args: { uuid: row.uuid },
              tooltip: v.$t("repair"),
              icon: "fa fa-scissors",
              icon_class: "is-small has-text-warning",
              click: (e) => {
                let uuid = e.detail.uuid;
                input_alert({
                  title: v.$t("why are you marking this as repair?"),
                })
                  .then((value) => {
                    post("/tailoring_outsourcing/repair", {
                      uuid: uuid,
                      reason: value,
                    })
                      .then(() => {
                        v.refresh();
                      })
                      .catch((error) => {
                        error_message(error);
                      });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              },
            });

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.order_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
